import migrateTutor from "./tutor/migration";

document.addEventListener( 'DOMContentLoaded', ( event ) => {
    migrateTutor();
} );
